todays-deliveries-task
  .row.task-wrap
    .col-lg-9
      .row
        .col-lg-4
          h5
            a(href="{o.show_path}" target="_blank")
              span.job_no.badge.badge-inverse-info
                | { o.job_no }
            span.client
              span.client_name { o.client_name }
              span.client_person_name(if="{ o.client_person_name }") &nbsp;( { o.client_person_name } )
            span.product
              span.clipboard-btn.label.label-sm.label-info.dropdown-toggle(data-toggle="dropdown")
                i.feather.icon-clipboard
              .dropdown-menu
                a.dropdown-item(href="#" onClick="{clipboard}" data-text="{ o.product_name }")
                  i.feather.icon-clipboard
                  | &nbsp;{ o.product_name }
                a.dropdown-item(href="#" onClick="{clipboard}" data-text="{ o.product_product_id }")
                  i.feather.icon-clipboard
                  | &nbsp;{ o.product_product_id }
              span.product_name
                span { o.product_name }
                br
                i { o.product_product_id }
          .address-wrap(if="{l}")
            a.location(href="{l.edit_path}" target="_blank")
              span.postcode(if="{l.postcode}") {l.postcode}
              span.state(if="{l.state}") {l.state}
              span.address3(if="{l.address3}") {l.address3 }
              span.address2(if="{l.address2}") {l.address2 }
              span.address1(if="{l.address1}") {l.address1 }
              br
              span.c_name1(if="{l.c_name1}") {l.c_name1 }
              span.c_name2(if="{l.c_name2}") {l.c_name2 }
              span.delivery-who
                span(if="{t.who == 1}") {locale().who_client}
                span(if="{t.who == 2}") {locale().who_partner}
                span(if="{t.who == 4}") {locale().who_mc}
              span.lt.mr-1.ml-1 &lt;
              span.delivery-shipfrom
                span { t.shipfrom_shortcut }
            br
            span.person(if="{p}")
              span.name(data-ruby="{ p.kana }" if="{p.name}") {p.name }
              span.tel(if="{p.tel}")
                span {p.tel }
                span(if="{p.tel_ext}") ({p.tex_ext})
            span.badge.badge-danger(if="{!p}") !
          .address-wrap(if="{!l}")
            span.badge.badge-danger !
          .delivery-options-wrap
            span.delivery-options
              span.delivery-options1(if="{do1}") { do1.contents }
              span.delivery-options2(if="{do2}") { do2.contents }
        .col-lg-8
          div.d-flex(if="{d.phase_fixed.value}")
            span.circle-icon
              span.badge.badge-success
                i.fas.fa-check
            span 確認済み
          div.d-flex(if="{!d.phase_fixed.value}")
            span.circle-icon
              span.badge.badge-warning
                i.fas.fa-exclamation
            span 確認中
          .order_description(if="{orderDescription()}")
            pre.desc { orderDescription() }
          .task_description(if="{taskDescription()}")
            pre.desc { taskDescription() }
        .delivery.attachments.col-12
          span.index { d.delivery.attachments.label }
        .delivery.attachments.col-12
          .fixed_status
            div.d-flex(if="{d.delivery.attachments.fixed_status.value}")
              span.circle-icon
                span.badge.badge-success
                  i.fas.fa-check
              span 確認済み
            div.d-flex(if="{!d.delivery.attachments.fixed_status.value}")
              span.circle-icon
                span.badge.badge-warning
                  i.fas.fa-exclamation
              span 確認中
          .attachments-items
            div.d-flex.flex-wrap
              div.mr-3(each="{key in d.delivery.attachments.simple_attachments}" if="{d.delivery.attachments.items[key].value}")
                i.fas.fa-check-circle.text-secondary.mr-1
                span {d.delivery.attachments.items[key].label}
            div.inspection_table(if="{d.delivery.attachments.items.inspection_table.value}")
              i.fas.fa-check-circle.text-secondary.mr-1
              span {d.delivery.attachments.items.inspection_table.label}
              span(class="label {d.delivery.attachments.items.inspection_table.klass} ml-1") {d.delivery.attachments.items.inspection_table.how_to_send}
              pre {d.delivery.attachments.items.inspection_table.memo_for_inspection}
            div.receipt_jmc_excel(if="{d.delivery.attachments.items.receipt_jmc_excel.value}")
              i.fas.fa-check-circle.text-secondary.mr-1
              span {d.delivery.attachments.items.receipt_jmc_excel.label}
              span(class="label {d.delivery.attachments.items.receipt_jmc_excel.klass} ml-1") {d.delivery.attachments.items.receipt_jmc_excel.delivery_pattern}
              pre {d.delivery.attachments.items.receipt_jmc_excel.to}
            div.receipt_by_system(if="{d.delivery.attachments.items.receipt_by_system.value}")
              i.fas.fa-check-circle.text-secondary.mr-1
              span {d.delivery.attachments.items.receipt_by_system.label}
              span(class="label {d.delivery.attachments.items.receipt_by_system.klass} ml-1") {d.delivery.attachments.items.receipt_by_system.delivery_pattern}
              pre {d.delivery.attachments.items.receipt_by_system.to}
            div.bills_by_system(if="{d.delivery.attachments.items.bills_by_system.value}")
              i.fas.fa-check-circle.text-secondary.mr-1
              span {d.delivery.attachments.items.bills_by_system.label}
              span.label.label-inverse-info-border.ml-1 {d.delivery.attachments.items.bills_by_system.bills_pattern}
          div.mb-3 { d.delivery.other_attachments.label }
          div.d-flex.flex-wrap.mb-3
            div.mr-3(each="{item in d.delivery.other_attachments.value}")
              i.fas.fa-check-circle.text-secondary.mr-1
              span.label.label-inverse-info(if="{item.inclusion}")
                | 同梱
              span.label.label-inverse-warning(if="{!item.inclusion}")
                | 別送
              span {item.filename}
          div.mb-3 {d.delivery.memo_for_delivery.label}
          div.mb-3
            pre.desc
              | { d.delivery.memo_for_delivery.value }
        .delivery.attachments_for_circle.col-12
          span.index { d.delivery.attachments_for_circle.label }
        .delivery.attachments_for_circle.col-12
          div.d-flex.flex-wrap
            div.mr-3(if="{d.delivery.attachments_for_circle.test_bar}")
              i.fas.fa-check-circle.text-secondary.mr-1
              span 試験棒
            div.mr-3(each="{item in d.delivery.attachments_for_circle.value}")
              i.fas.fa-check-circle.text-secondary.mr-1
              span {item}
          
      .row.row-calendar.mt-3
        .col-12
          tasks-schedules-calendar(tag-scope="{this.tagScope}")
          tasks-delivered-calendar(tag-scope="{this.tagScope}")
          tasks-delivered-total(tag-scope="delivery_record_sum_{opts.taskable_id}" data-total="{ total() }")
    .col-lg-3.control-wrap(data-id="{opts.taskable_id}")
      .only-print-block
        | { this.locale().box_num }
      .control
        todays-deliveries-checkbox(value="{opts.taskable_id}" checkbox_class="{opts.checkbox_class}")
        inputs-without-label-number-plus(name="numbers[{opts.taskable_id}]" value="{record_number()}" digits="2" min="1" no-dispatch="{true}" data-toggle="tooltip" data-placement="top" data-original-title="{this.locale().exp_total}")
      .only-print-block
        | { this.locale().value }
      .text-wrap.form-inline
        span.value-wrap(data-toggle="tooltip" data-placement="top" data-original-title="{this.locale().exp_value}")
          inputs-without-label-textfield(name="values[{opts.taskable_id}]" value="{record_value()}" no-dispatch="{true}")
      .alert.alert-warning(if="{isDifferentTodaysValue()}")
        i.fas.fa-exclamation
        | { this.locale().different_todays_num_pre }
        | { this.record_todays_value() }
        | { this.locale().different_todays_num_suf }
      .only-print-block
        | { this.locale().memo }
      .text-wrap.form-inline
        span.memo-wrap(data-toggle="tooltip" data-placement="top" data-original-title="{this.locale().exp_memo}")
          inputs-without-label-textfield(name="memos[{opts.taskable_id}]" value="{record_memo()}" no-dispatch="{true}")
      .only-print-block
        | { this.locale().memo1 }
      .text-wrap2.form-inline
        span.memo2-wrap(data-toggle="tooltip" data-placement="top" data-original-title="{this.locale().exp_memo1}")
          inputs-without-label-textarea(name="memos1[{opts.taskable_id}]" value="{record_memo1()}" no-dispatch="{true}")
      .save-btn-wrap.mt-1
        span.btn.btn-primary(if="{!recordExist()}" onClick="{onClickEachSave}" data-id="{opts.taskable_id}")
          i.feather.icon-save
          | {locale().btn_save}
        span.btn.btn-primary(if="{recordExist()}" onClick="{onClickEachSave}" data-id="{opts.taskable_id}")
          i.feather.icon-save
          | {locale().btn_update}
  hr.only-print-block
  script(type="typescript").
    this.mixin('todays.deliveries.task');
  style(scoped).
    :scope {
      display: block;
      page-break-inside: avoid;
    }
    span.index {
      font-size: 1rem;
      font-weight: bold;
      margin-bottom: 1rem;
      margin-top: 1.5rem;
      display: block;
    }
    .control,
    .save-btn-wrap{
      text-align: right;
    }
    .row.row-calendar {
      padding-top: 2px !important;
      padding-bottom: 10px;
    }
    .row.task-wrap {
      margin-bottom: 40px;
    }
    .client {
      vertical-align: bottom;
      margin-left: .5rem;      
    }
    .product {
      vertical-align: bottom;
      display: block;
      margin-top: .8rem;
      position: relative;
      
    }
    .clipboard-btn {
      position: absolute;
      display: inline-block;
      padding: 10px;
      margin-top: 3px;
    }
    .product_name {
      font-size: .85rem;
      display: inline-block;
      margin-left: 46px;
      margin-top: 4px;
    }
    .address-wrap {
      position: relative;
      margin-top: 2rem;
    }
    .address-wrap span{
      display: inline-block;
    }
    .state,
    .address3,
    .address2,
    .address1 {
      margin-right: .5rem;
    }
    .postcode {
      position: absolute;
      top: -1em;
      left: 0;
      right: 0;
      margin: auto;
      font-size: 0.75em;
      white-space: nowrap;
    }
    .c_name1,
    .c_name2 {
      margin-right: .5rem;
    }
    .name {
      margin-right: 1rem;
      font-weight: bold;
    }
    .tel {
      font-size: 75%;
    }
    .person {
      margin-top: 8px;
    }
    .col-md-4 {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    todays-deliveries-checkbox {
      vertical-align: middle !important;
      position: relative;
      height: 20px;
      margin-right: 6px;
    }
    .value-wrap input{
      width: 6rem !important;
    }
    .text-wrap,
    .text-wrap2 {
      /* text-align: right; */ 
      /* width: 282px; */
      justify-content: flex-end;
    }
    .value-wrap,
    .memo-wrap,
    .text-wrap2 {
      margin-top: 4px;
    }
    .memo-wrap {
      margin-left: 1px;
    }
    .value-wrap,
    .value-wrap inputs-without-label-textfield,
    .value-wrap inputs-without-label-textfield input,
    .memo-wrap,
    .memo-wrap inputs-without-label-textfield,
    .memo-wrap inputs-without-label-textfield input,
    .memo2-wrap,
    .memo2-wrap inputs-without-label-textarea,
    .memo2-wrap inputs-without-label-textarea textarea {
      display: block;
      width: 100% !important;
    }
    .value-wrap inputs-without-label-textfield input {
      text-align: right;
    }
    tasks-delivered-total {
      display: block;
      margin-top: .5rem;
    }
    .lt{
      font-size: 80%;
    }
    .delivery-who,
    .delivery-options,
    .delivery-shipfrom {
      font-size: 80%;
      border: 1px solid #ccc;
      padding: 2px 4px;
    }
    @media print{
      todays-deliveries-checkbox {
        display: none;
      }
      input[type="text"],
      input[type="number"],
      textarea {
        border: 0 !important;
        overflow: visible !important;
      }
      inputs-without-label-number-plus .btn,
      .save-btn-wrap {
        display: none;
      }
    }
